// OrderDetailMobile.tsx
import React from "react";
import { Button, Card, Checkbox, Col, Row, Space, Steps, Typography } from "antd";
import { FileAddFilled } from "@ant-design/icons";
import { AppBarCustom } from "../../../components/AppBarCustom";
import { ButtonCustom } from "../../../components/ButtonCustom";
import { OrderDetail, OrderItem } from "../model/orderDetail.ui";
import { STATUS_TAGS as STATUS_ORDER } from "../../../utils/constants";

const { Title, Text } = Typography;

interface OrderDetailMobileProps {
  orderDetail?: OrderDetail;
  currentStep: number;
  totalAmount: number;
  handleBack: () => void;
  handleCheckboxChange: (id: number, isSelected: boolean) => void;
  handleDownloadFile: () => void;
  handleSave: () => void;
  handleSendOrder: () => void;
}

export const OrderDetailMobile: React.FC<OrderDetailMobileProps> = ({
  orderDetail,
  currentStep,
  totalAmount,
  handleBack,
  handleCheckboxChange,
  handleDownloadFile,
  handleSave,
  handleSendOrder,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100dvh", overflow: "hidden" }}>
      <AppBarCustom title="注文詳細" /* Chi tiết Order */ handleBack={handleBack} />

      <div style={{ display: "flex", flexDirection: "column", flex: 1, overflowY: "auto", padding: "12px" }}>
        <Card style={{ borderRadius: 16, marginBottom: 16 }}>
          <Space orientation="vertical" size={6} style={{ width: "100%" }}>
            <Title level={5} style={{ margin: 0 }}>
              {orderDetail?.order_number}
            </Title>
            <Text type="secondary">
              元提案: {/* Đề xuất gốc */} <Text strong>{orderDetail?.order_number}</Text>
            </Text>
            <Text type="secondary">
              顧客名: {/* Khách hàng */} <Text strong>{orderDetail?.customer?.company_in_name}</Text>
            </Text>
          </Space>
        </Card>

        <Card style={{ borderRadius: 16 }}>
          <Text style={{ fontSize: 16, fontWeight: "bold", display: "block", marginBottom: 12 }}>
            注文ステータス {/* Trạng thái đơn hàng */}
          </Text>
          <Steps
            direction="vertical"
            current={currentStep}
            items={[
              { title: STATUS_ORDER.pending.label },
              { title: STATUS_ORDER.waiting_final_confirmation.label },
              { title: STATUS_ORDER.confirmed.label },
              { title: "完了" /* Hoàn Tất Đơn */ },
            ]}
          />
        </Card>

        <Title level={5} style={{ margin: "16px 0 12px 0" }}>
          確定済み商品・スケジュール {/* Sản phẩm & Lịch đã xác nhận */}
        </Title>

        <Space orientation="vertical" style={{ width: "100%" }} size={12}>
          {orderDetail?.order_items?.map((item: OrderItem) => {
            const productName = item.product_name;
            const quantity = item.order_quantity;
            const proposedPrice = item.proposed_price;
            const subtotal = Number(proposedPrice ?? 1) * Number(quantity ?? 0);

            return (
              <Card
                key={item.id}
                style={{
                  borderRadius: 16,
                  backgroundColor: item.is_selected ? "#DBEAFE" : "#fff",
                  border: item.is_selected ? "1px solid #2563EB" : "1px solid #f0f0f0",
                }}
                onClick={() => handleCheckboxChange(item.id!, !item.is_selected)}
              >
                <Row justify="space-between" align="middle">
                  <Checkbox checked={item.is_selected} />
                  <Col flex={1} style={{ marginLeft: 24, marginRight: 16 }}>
                    <Text strong style={{ fontSize: 16 }}>
                      {productName}
                    </Text>
                    <br />
                    <Text type="secondary" style={{ fontSize: 13 }}>
                      提案価格: ¥{proposedPrice ?? "N/A"} {/* Giá đề xuất */}
                    </Text>
                  </Col>
                  <Col style={{ textAlign: "right" }}>
                    <Text strong style={{ fontSize: 14 }}>
                      {quantity}
                    </Text>
                    <br />
                    <Text strong style={{ color: "#b91c1c", fontSize: 14 }}>
                      ¥{subtotal?.toLocaleString()}
                    </Text>
                  </Col>
                </Row>
              </Card>
            );
          })}
        </Space>
      </div>

      <div style={{ padding: 16, backgroundColor: "#fff", textAlign: "right", boxShadow: "0 -2px 10px rgba(0,0,0,0.05)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <Button icon={<FileAddFilled />} onClick={handleDownloadFile}>
            ファイルをダウンロード {/* Tải file */}
          </Button>
          <Text style={{ color: "red", fontSize: 18, fontWeight: "bold" }}>
            合計: ¥{totalAmount?.toLocaleString()} {/* Tổng */}
          </Text>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <ButtonCustom
            title="保存" /* Lưu */
            backgroundColor="#F1F5F9"
            color="#0F172A"
            handlePress={handleSave}
          />
          <div style={{ width: 16 }} />
          <ButtonCustom
            title="注文送信" /* Gửi đơn hàng */
            backgroundColor="#2563EB"
            handlePress={handleSendOrder}
          />
        </div>
      </div>
    </div>
  );
};